'use strict';

import React, { Component } from 'react';
import CollectionItemComponent from './CollectionItemComponent';
import globalConfig from '../../settings/config';

class CollectionsListComponent extends Component {
  constructor(props) {
    super(props);

    // this.state = {
    //   selectedCollection: globalConfig.collections.default.name,
    // };

    //this.handleCollectionSelected = this.handleCollectionSelected.bind(this);
  }

  printCollectionItems() {

    let collections = [];
    collections.push(globalConfig.collections.default);
    const keys = Object.keys(globalConfig.collections);

    for (let key of keys) {
      if (key === 'default') {
        continue;
      } else {
        collections.push(globalConfig.collections[key]);
      }
    }

    return collections.map((item, index) => (
      <CollectionItemComponent
        data={item}
        key={`collection-${index}`}
        selectedCollection={this.props.selectedCollection}
        handleCollectionSelected={this.props.handleCollectionSelected}
      />
    ));
  }

  // handleCollectionSelected(selectedCollection) {
  //   if (this.state.selectedCollection != selectedCollection) {
  //     this.setState({
  //       selectedCollection,
  //     });
  //     //will conplete the fb call here when fb is ready
  //   }
  // }

  render() {
    return (
      <div className="map-menu__panel map-menu__panel--active">
        <ul className="collections-list">
          {this.printCollectionItems()}
        </ul>
      </div>
    );
  }
}

export default CollectionsListComponent;
